var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21157 16.1119C8.49542 16.3895 8.94928 16.3889 9.23236 16.1105L16.2593 9.19916C16.6581 8.80695 16.6588 8.16503 16.2598 7.77302C14.2463 5.79467 11.1549 2.74709 9.22562 0.852252C8.94513 0.576776 8.49746 0.576486 8.21494 0.849874C7.92175 1.13358 7.92014 1.60314 8.21122 1.889C9.48464 3.1396 10.9755 4.60963 12.4421 6.05327C13.0801 6.68133 12.6355 7.76793 11.7402 7.76792L1.44953 7.76788C1.05332 7.76788 0.732124 8.08907 0.732123 8.48528C0.732121 8.88149 1.05331 9.20268 1.44952 9.20268L11.7403 9.20271C12.6356 9.20271 13.0798 10.2889 12.441 10.9162L8.21053 15.0708C7.91923 15.3568 7.9197 15.8264 8.21157 16.1119Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowWhite);
export default __webpack_public_path__ + "static/media/rightArrowWhite.5d246291e90608fb5fbaaf3c034d2b4a.svg";
export { ForwardRef as ReactComponent };